<template>
<footer id="footer" class="text-center text-lg-left">
  <!--b-container class="py-4">
    <b-row>
      <b-col cols="3">
				<p class="text-dark font-weight-bold" style="font-size: 1.1rem;">Graphmetrix</p>
				<p>
					<b-link
						to="/"
						@click.native="scrollToTop()"
						>
						Home
					</b-link>
				</p>	
				<p>
					<b-link
						to="/about"
						@click.native="scrollToTop()"
						>
						About us
					</b-link>
				</p>
				<p>
					<b-link
						href="https://forms.zohopublic.com/graphmetrix/form/ContactUs/formperma/4OMSwRrUmWo7aROfkChl9K7AVaPZWcvTwMOOtA41I6s"
						target="_blank">
						Contact Us
					</b-link>
				</p>
				<div class="fa-wrapper pb-5">
					<b-link
						href="https://www.linkedin.com/company/graphmetrix"
						target="_blank"
						>
						<font-awesome-icon :icon="faLinkedin" />
					</b-link>
				</div>
				<div class="fa-wrapper">
					<b-link
						href="https://www.youtube.com/channel/UCRxK7CYIGu4D3uHxWnSWbFA"
						target="_blank"
						>
						<font-awesome-icon :icon="faYoutubeSquare" />
					</b-link>
				</div>
				<div class="fa-wrapper">
					<b-link
						href="https://vimeo.com/user97466398"
						target="_blank"
						>
						<font-awesome-icon :icon="faVimeo" />
					</b-link>
				</div>
			</b-col>
			<b-col cols="5">
				<p class="text-dark font-weight-bold" style="font-size: 1.1rem;">Solutions</p>
				<p>
					<b-link
						to="/building"
						@click.native="scrollToTop()"
						>
						Architecture, Engineering, Construction, Operations
					</b-link>
				</p>
				<p>
					<b-link
						to="/productivity"
						@click.native="scrollToTop()"
						>
						Productivity
					</b-link>
				</p>
				<p>
					<b-link
						to="/property"
						@click.native="scrollToTop()"
						>
						Property
					</b-link>
				</p>
			</b-col>
		</b-row>
	</b-container-->
	<b-container class="pt-3">
		<b-row class="text-left">
			<b-col cols="12" sm="4" class="d-flex" order="3" order-sm="1">
				<div class="mr-3"><p>&copy; 2024 Graphmetrix, Inc. All rights reserved</p></div>
      </b-col>
			<b-col cols="12" sm="4" class="d-flex" order="2" order-sm="2">
				<div><p><b-link to="/about" @click.native="scrollToTop()">About</b-link></p></div>
				<div style="color: #788698;" class="mx-3">|</div>
				<div><p><b-link to="/privacy" @click.native="scrollToTop()">Privacy</b-link></p></div>
				<div style="color: #788698;" class="mx-3">|</div>
				<div><p><b-link to="/terms" @click.native="scrollToTop()">Terms of Service</b-link></p></div>
			</b-col>
			<b-col cols="12" sm="4" class="d-flex" order="1" order-sm="3">
				<div class="ml-sm-auto mr-3">
					<p><b-link href="https://forms.zohopublic.com/graphmetrix/form/ContactUs/formperma/4OMSwRrUmWo7aROfkChl9K7AVaPZWcvTwMOOtA41I6s" target="_blank" style="text-decoration: none;">Contact</b-link></p>
				</div>
				<div>
					<div class="fa-wrapper">
						<b-link href="https://forms.zohopublic.com/graphmetrix/form/ContactUs/formperma/4OMSwRrUmWo7aROfkChl9K7AVaPZWcvTwMOOtA41I6s" target="_blank">
							<font-awesome-icon :icon="faEnvelope" />
						</b-link>
					</div>
					<div class="fa-wrapper">
						<b-link
							href="https://www.linkedin.com/company/graphmetrix"
							target="_blank"
							>
							<font-awesome-icon :icon="faLinkedin" />
						</b-link>
					</div>
					<div class="fa-wrapper">
						<b-link
							href="https://www.youtube.com/channel/UCRxK7CYIGu4D3uHxWnSWbFA"
							target="_blank"
							>
							<font-awesome-icon :icon="faYoutubeSquare" />
						</b-link>
					</div>
					<div class="fa-wrapper">
						<b-link
							href="https://vimeo.com/user97466398"
							target="_blank"
							>
							<font-awesome-icon :icon="faVimeo" />
						</b-link>
					</div>
				</div>
			</b-col>
    </b-row>
  </b-container>
</footer>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons'
import { faLinkedin, faYoutubeSquare, faVimeo } from '@fortawesome/free-brands-svg-icons';
export default {
	name: 'GmxFooter',
	components: {
		FontAwesomeIcon
	},
	data () {
		return {
			faEnvelope,
			faLinkedin,
			faYoutubeSquare,
			faVimeo
		}
	},
	methods: {
		img: function (image) {
			require(image)
		},
		scrollToTop: function () {
			window.scrollTo(0,0);
		},
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
footer {
	/*background-color: #1f1f1f;*/
	background-color: #f8f9fa;
	/*padding: 64px 16px 24px 16px;*/
}
p {
	font-family: Arial;
	/*margin-bottom: 0px;*/
	color: #788698;
}
a {
	color: #788698;
	text-decoration: none; 
}
a:hover {
	color: #788698;
	text-decoration: underline;
}
/*a.bold-link {
	color: #f9f9f9;
	font-weight: 600;
}
a.bold-link:hover {
	color: #585aff;
	text-decoration: none;
}*/
/*h4 {
    color: #585aff;
    font-family: Trebuchet MS, Helvetica, sans-serif;
    font-size: 2rem;
}
ul {
    list-style: none;
    padding-inline-start: 18px;
}
li {
    font-size: 1.1rem;
    line-height: 1.8;
    color: #788698;
}
a {
    color: #788698;   
}
.fa-wrapper {
    display: inline-block;
    padding-right: 8px;
}
.fa-wrapper>a:hover {
    color: #585aff;
}
@media (max-width: 991px) {
    ul {
	padding-inline-start: 0px;
    }
    .fa-wrapper {
	padding-left: 8px;
    }
}*/
</style>
